<style scoped lang="scss">
.not-verified-alert {
  background: white;
  border: solid 3px red;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  padding: 8px;
  margin: 8px;
  .info-icon {
    display: flex;
    padding: 0 20px;
    align-items: center;
    justify-content: center;
  }
}
.design-login {
      position: absolute;
    bottom: -15px;
    left: 49px;
    font-size: 11px;
    font-weight: 100;
}
.home-page-template .ivu-card-head {
  display: none;
}
.spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
hr.divider {
  border: 1px solid #f2f2f2;
  background: transparent;
  margin: 10px 50px;
}

.sticky{
  position: fixed;
  width: 100%;
  z-index: 9;
  background: #fff;
  padding: 10px;
  top: 84px;
  right: 0;
  /* border-bottom: 1px solid rgb(221, 221, 221); */
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
}

.featured-content-loader {
  height: 185px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 768px) {
  .home-header {
    display: none;
  }
}
</style>

<style lang="scss">
.account-verification-modal{
  .ivu-modal-footer{
    border: none;
    padding-top: 0;
  }
  .ivu-modal{
    border: solid 3px red;
    border-radius: 10px;
  }
}
.verification-modal-body {
  .input-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    input {
      text-align: center;
    }
  }
}
.mCustomModal .ivu-modal-footer {
  padding:0;
}
.mCustomModal .ivu-modal-footer:after {
  content: ' ';
  width: 20px;
  height: 20px;
  position:absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 15px solid #fff;
  bottom: -20px;
}
.mCustomModal .ivu-modal-header{
  padding: 0;
  border-bottom: none;
}
.mCustomModal .ivu-modal{
  bottom: 15px;
  top: auto;
  position: absolute;
  left: 0;
  right: 0;
  width: 80vw !important;
  margin: 0 auto;
}
.systemAlert .ivu-modal {
  top: 30px;
}
.systemAlert .ivu-modal-content {
  overflow: hidden !important;
  background-color: transparent !important;
  border-radius: 10px 10px 0px 0px !important;
}
.systemAlert .ivu-modal-header {
  padding: 0;
  border-bottom: 0px
}
.systemAlert .ivu-modal-body {
  padding: 5px 0px;
  background-color: #f0f0f0;
  border-radius: 0 0;
}
.systemAlert .ivu-modal-footer {
  border-top: 0px solid #e9eaec;
  padding: 0px 0px;
}
.systemAlert .ivu-modal-close .ivu-icon-ios-close-empty {
  top: -6px;
  color: #fff;
}
.systemAlert .swiper-pagination-bullet {
    background: white !important;
    opacity: 1 !important;
}
.swiper-pagination-bullet-active {
    opacity: 1;
    background: var(--primary-color) !important;
}
</style>

<template>
  <div class="home-page-template" v-if="isAuthenticated" style="position:relative">
    <!-- <AlertNotif></AlertNotif> -->
    <Modal
      v-model="verificationModal"
      @on-cancel="closeVerificationModal">
      <div slot="header">
        <h4>
          Account Verification
        </h4>
      </div>
      <div class="verification-modal-body"
        style="display:flex; justify-content: center; flex-direction: column; align-items: center;">
        <p>
          We have sent you an access code via SMS/Email for verification
        </p>
        <div class="input-wrapper">
          <Input
            style="width: 70%; margin-top: 10px; text-align: center;"
            size="large"
            :disabled="isVerifying"
            clearable
            v-model="verificationCode"
            placeholder="Enter verification code"
          />
        </div>
        <div class="input-wrapper">
            <Button
              @click="verifyCode"
              :disabled="isVerifying"
              :loading="isVerifying"
              style="margin-top: 10px;"
              long
              size="large"
              type="primary"
            >Verify</Button>
        </div>
        <div style="flex-direction: column;" class="input-wrapper">
          <small style="margin-top: 10px;">{{ mobile }}</small>
          <small>{{ email }}</small>
          <a style="margin-top: 4px;" @click="resendCode">Resend Code</a>
        </div>
      </div>
      <div slot="footer">
        <p></p>
      </div>
    </Modal>

      <Modal class="account-verification-modal" v-model="AccountVerificationModal" :closable="false" :mask-closable="false">
        <div slot="header">
          <h4>
            Account Verification
          </h4>
        </div>
        <div class="verification-modal-body"
          style="display:flex; justify-content: center; flex-direction: column; align-items: center; text-align: center;">
          <p>
            Either your email or phone number must first be verified.
          </p>
          <div class="input-wrapper">
             <Button
                @click="showVerifyModal"
                style="margin-top: 10px;"
                size="large"
                type="primary"
              >OK</Button>
          </div>
        </div>
        <div slot="footer" style="border: none"></div>
      </Modal>
    <app-layout class="home-page-template">
      <!-- <Row type="flex" justify="center" :style="{padding: '0 15px'}">
        <Col :xs="24" :sm="24" :md="24" :lg="24" :style="{padding: '15px 0 0'}">
          <div class="home-header">
            <Button style="float:right" size="large" @click="setMemberMethod('signup')" v-if="userInfo && userInfo.user_type === 'guest'" type="primary">Be a Member</Button>
            <router-link to="/profile" style="float:left;margin-right:10px">
              <Avatar size="large" v-if="userInfo.user_type === 'guest'" icon="person" style="border:1px solid #ddd;"></Avatar>
            </router-link>
            <h2 align="left" :style="{lineHeight: ( userInfo && userInfo.user_type === 'guest' ) ? '18px':'14px'}">
              <small><a v-if="userInfo && userInfo.user_type === 'guest'" @click="setMemberMethod('signin')" style="font-size:12px">Already a Member?</a></small><br/>
              <span v-if="userInfo && userInfo.user_type === 'guest'" style="color:#aaa;font-size:12px">Guest</span>
            </h2>
            <p align="left" style="line-height:10px">{{(brandPlanInfo.title) ? '': ""}}</p>
          </div>

          <div class="home-header sticky" v-if="userInfo.user_type != 'guest'">
            <router-link to="/profile" style="float:left;margin-right:10px">
              <Avatar size="large" v-if="userInfo.user_type != 'guest'" :src="userInfo.avatar" style="border:1px solid #ddd;"></Avatar>
            </router-link>
            <h2 align="left" :style="{lineHeight: ( userInfo && userInfo.user_type === 'guest' ) ? '18px':'14px'}">
              <span v-if="userInfo && userInfo.user_type != 'guest'"><span style="color:#aaa">Hi,</span> {{userInfo.display_name}}</span>
            </h2>
            <p align="left" style="line-height:10px">{{(brandPlanInfo.title) ? '': ""}}</p>
          </div>
        </Col>
      </Row> -->
      <Row type="flex" justify="center">
        <!-- <Col :span="24" v-if="showUnverifiedAlert">
          <div class="not-verified-alert">
            <div class="info-icon">
              <Icon style="height: 18px;" color="#ed4014" type="information-circled"></Icon>
            </div>
            <div>
              <b style="font-size: 16px;">Account Verification</b><br>
              <div style="font-size: 15px;">
                Either your email address or phone number must be verified.
                <a style="font-size: 15px" @click="verificationModal = true">Please click here to verify</a>
              </div>
            </div>
          </div>
        </Col> -->
        <Col :span="24" style="">
          <Affix :offset-top="84">
            <div class="home-header" v-if="userInfo.user_type == 'guest'" :style="{padding: '10px 15px'}" style="background:#fff;border-bottom: 1px solid #ddd">
              <Button style="float:right" size="large" @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'Guest Sign Up'});toSignUp()" v-if="userInfo && userInfo.user_type === 'guest'" type="error">Join</Button>
              <a @click="onviewprofile()" style="float:left;margin-right:10px">
                <Avatar size="large" v-if="userInfo.user_type === 'guest'" :src="userInfo.avatar" alt="" style="border:1px solid #ddd; background: white;"></Avatar>
              </a>
              <h2 align="left" :style="{lineHeight: ( userInfo && userInfo.user_type === 'guest' ) ? '18px':'14px'}">
                <small><a v-if="userInfo && userInfo.user_type === 'guest'" @click="setMemberMethod('signin')" style="font-size:12px;">Already a Member?</a></small><br/>
                <span v-if="userInfo && userInfo.user_type === 'guest'" style="color:#aaa;font-size:12px">Guest</span>
              </h2>
            </div>
          </Affix>
          <div class="home-header" v-if="userInfo && userInfo.user_type !== 'guest'" :style="{padding: '10px 15px'}">
            <ResilienceDoughnut v-if="isAllowPoints" msize="small" mid="home-res" :isHideLegend="true" :isSliceClickable="false" :profile="userInfo" />
           
            <a @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'View Profile'});onviewprofile(userInfo.id)" v-if="!isAllowPoints" style="float:left;margin-right:10px">
              <Avatar size="large" v-if="userInfo && userInfo.user_type != 'guest'" :src="userInfo.avatar" alt="" style="border:1px solid #ddd; background:white"></Avatar>
            </a>
            <h2 v-if="!isAllowPoints" align="left" :style="{lineHeight: ( userInfo && userInfo.user_type === 'guest' ) ? '18px':'14px'}" style="margin-left:40px;padding-right:40px;position:relative" >
              <span v-if="userInfo && userInfo.user_type != 'guest'" class="truncate" style="display: block;margin-top: 12px;width: 94%;display: inline-block; height: 20px;">
                <span style="color:#aaa;width:100%" >Hi,</span> {{userInfo.display_name}}</span>
              <!-- <span style="position:absolute;top:-0px;right:0;z-index:1"
                v-if="leadership && leadership.subscribed">
                <router-link :to="admin"><Avatar size="large" :src="groupDisplayImage(leadership)"></Avatar></router-link>
              </span> -->
            </h2>
            <!-- <p align="left" style="line-height:10px">{{(brandPlanInfo.title) ? '': ""}}</p> -->
          </div>
        </Col>
      </Row>
      <div class="feature-feed-wrapper" style="margin-top: 0px;" v-if="isAuthenticated && userInfo && userInfo.user_type != 'guest'">
        <div
          v-if="isLoadingBrandInfo"
          class="featured-content-loader">
          <Icon type="load-c" size=18 class="spinner-load"></Icon>
        </div>
        <FeaturedFeedComponent v-else/>
      </div>
      <div v-if="isAuthenticated && userInfo && userInfo.user_type == 'guest'">
        <div 
          v-if="isLoadingBrandInfo"
          class="featured-content-loader">
          <Icon type="load-c" size=18 class="spinner-load"></Icon>
        </div>
        <FeaturedFeedComponent v-else/>
      </div>

      <div v-if="isAuthenticated && userInfo">
        <FeedList :section="'none'"></FeedList>
      </div>
      <!-- <p align="center" v-if="userInfo.user_type !== 'guest'" style="padding:0px 10px 20px">
        <a @click="showAlert()">Call to Action</a></p> -->

      <Row type="flex" v-if="false" justify="center">
        <Col :xs="24" :sm="24" :md="24" :lg="24">
          <div id="cover-photo" style="position:relative;background: #000;height:30vh;margin-top: 15px;">
            <img alt=" " src="@/assets/cover.jpg" width="100%" />
            <div style="position:absolute;top:0px;padding:20% 0;background: rgba(0,0,0,.5);left:0;right:0">
              <h1 align="center" style="color:white">Partners For Change</h1>
              <p align="center" style="color:#aaa">Sharpen Warrior ALLIANCE FOR THE PHILIPPINES</p>
              <p style="padding:10px 0 0" align="center" v-if="userInfo && userInfo.user_type === 'guest'">
                <button class="ivu-btn ivu-btn-error ivu-btn-large" @click="toSignUp()">Join</button>&nbsp;
                <button class="ivu-btn ivu-btn-default ivu-btn-large" @click="setMemberMethod('signin')">Already a Member</button>
              </p>
              <p v-else style="padding:10px 0 0" align="center">
                <button class="ivu-btn ivu-btn-error ivu-btn-large" @click="createOrganization()">Register Organization</button>
              </p>
            </div>
          </div>
        </Col>
        <Col :xs="24" :sm="24" :md="24" :lg="24">
          <div style="min-height:30vh;background:white">
            <div style="padding:20px">
              <Card border>
                <img alt=" " src="@/assets/about-bg.jpg" width="100%" />
                <h3 align="center">About Us</h3>
                <div style="margin-top:10px;text-align:center">
                  <p><b>Sharpen Warrior Alliance for the Philippines</b> is an umbrella organization of groups that support the Duterte administration.</p>

                  <br/><p>Alliance Building</p>
                  <hr class="divider">
                  <p>To establish a broader and a more responsive alliance that can effectively mobilize support for government initiatives and positive change.</p>

                  <br/><p>Responding to the Issues/Needs of the Members of the Alliance</h3>
                  <hr class="divider">
                  <p>To raise the needs and issues of the members of the alliance to the concerned agencies.</p>

                  <br/><p>Marawi Rehabilitation</p>
                  <hr class="divider">
                  <p>To help build livable and sustainable communities as a result of effective private and public collaboration</p>
                </div>
              </Card>
            </div>
          </div>
        </Col>
        <Col :xs="24" :sm="24" :md="24" :lg="24">
          <div style="min-height:30vh;background:#f2f2f2;">
            <div style="padding:20px">
              <Card shadow>
                <h3 align="center">Membership</h3>
                <p style="margin-top:10px" align="center">The Alliance welcomes membership of individuals and organizations, both local and abroad, who have autonomous functions and structures and are willing to accept the principles and agenda of Sharpen Warrior for the Philippines as the basis of unity.</p>
                <p align="center" style="margin-top:20px" v-if="userInfo && userInfo.user_type === 'guest'">
                  <Button type="error" size="large" @click="toSignUp()">Join</Button></p>
              </Card>
            </div>
          </div>
        </Col>
        <Col :xs="24" :sm="24" :md="24" :lg="24">
          <div style="min-height:20vh;background:#ddd;">
            <div style="padding:20px">
              <Card shadow>
                <img alt=" " src="@/assets/all.jpg" width="100%" />
                <h3 align="center">Contact Us</h3>
                <p style="margin-top:10px" align="center">Address: 2nd Flr., Right Wing, Matina Town Square, Matina Davao City</p>
                <p align="center">tapangmalasakit.ph@gmail.com</p>
              </Card>
            </div>
          </div>
        </Col>
        <Col :xs="24" :sm="24" :md="24" :lg="24">
          <div style="margin-bottom:60px;min-height:30vh;background:#ddd;">
            <div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d989.8844629177286!2d125.59691795301516!3d7.063458865078333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x32f96d6310a77eaf%3A0x6ce43b50cf7bb650!2sTapang+at+Malasakit!5e0!3m2!1sen!2sph!4v1516185656367" width="100%" height="250px" frameborder="0" style="border:0"></iframe>
            </div>
            <div class="site-info" style="background:#424242;text-align:center;color:white;padding:10px">
              All Rights Reserved © 2018
              <br>
              Sharpen Warrior Alliance for the Philippines.
              <br>
              Like us on <a target="_blank" href="https://www.facebook.com/TapangMalasakitPH">FACEBOOK </a>
            </div>
          </div>
        </Col>
      </Row>
      <!-- <Modal
          class="mCustomModal"
          title="Title"
          :on-cancel="dismiss"
          v-model="$store.state.base.showInstructionCard"
          :mask-closable="false">
          <p slot="header">
              <Avatar style="margin:0 auto;border-radius:100px;position:absolute;left:0;right:0;top:-30px;background:white;padding:5px; width:70px;height:70px" :src="appLogo"></Avatar>
          </p>
          <p align="center">To add this web app to the home screen: <br/>tap <Icon type="ios-upload-outline" style="color:blue" size="20"></Icon>
          and then <b>Add to Home Screen</b>.</p>
          <div slot="footer">
          </div>
      </Modal> -->
      <!-- <img v-if="showSystemAlert" alt=" " @click="onRemindLater()" style="z-index:1001;height:25px; width:25px;position:fixed;top:0;right:0;margin:5px 10px 0 0;" src="@/assets/close.png"> -->
      <!-- <Modal
        v-model="showSystemAlert"
        title="System Alert"
        class-name="systemAlert"
        :mask-closable="false"
        :closable="false"
        @on-cancel="onCallToActionClose()">
        <div slot="header">
          <div style="background:#EF5350;height:35px;color:#fff">
            <strong style="font-size:16px;height:35px;line-height:35px">A Call to Action</strong>
          </div> -->
          <!-- <img v-if="showSystemAlert" alt=" " @click="onRemindLater()" style="height:25px; width:25px;position:fixed;top:0;right:0;margin:5px 10px 0 0;" src="@/assets/close.png"> -->
        <!-- </div>
          <div v-if="isAuthenticated && showSystemAlert && shareableActivityData.length > 0" >
            <system-alert-component @currentSharedShown="setCurrentSharedShown" :shareables="shareableActivity"></system-alert-component>
          </div>
        <div slot="footer">
          <div style="display:flex;align-items:center; background: #f0f0f0; border-radius: 0px 0px 10px 10px;padding:8px" v-if="isAuthenticated">
            <div>
              <Button v-if="userInfo.user_type != 'guest'" @click="skipAlert(userInfo.id, shareableActivity.data[currentShared])" type="text" style="color:#2b85e4;padding-left:5px;padding-right:5px">Skip</Button>
            </div>
            <div style="display:flex;align-items:center;height: 32px;width: 100%;justify-content: flex-end;"> -->
                <!-- <Button v-if="isShareableActivity" type="text" style="color:#2b85e4;padding-left:15px;padding-right:15px;">
                  <a target="_blank" :href="shareableActivity.data[currentShared].data.url">View Post</a>
                </Button> -->
                <!-- <div>
                  <span style="height: 28px;line-height: 28px;width:80px;display: block;margin-top: 0px;background: #41579b;border-radius: 20px;text-align: center;">
                    <span @click="shareAlert(userInfo.id, shareableActivity.data[currentShared])" style="background:#3b5998;color:white;padding:0 10px">
                      <span><Icon type="social-facebook"></Icon> Share</span>
                    </span> -->
                    <!-- <social-sharing :url="shareURL"
                      title="TM"
                      description="Sharpen Warrior"
                      @close="closeSocialSharing"
                      inline-template>
                      <div>
                          <network network="facebook">
                            <span style="background:#3b5998;color:white;padding:0 10px">
                              <Icon type="social-facebook"></Icon> Share
                            </span>
                          </network>
                      </div>
                    </social-sharing> -->
                  <!-- </span>
                </div>
              </div>
          </div>
          <div v-else style="display:flex;align-items:center; height:10px;background: #f0f0f0; border-radius: 0px 0px 10px 10px;padding:8px"></div>
          <div class="swiper-pagination2" slot="pagination" style="position:initial !important;text-align: center; margin-top: 8px;" ></div>
        </div>
      </Modal> -->

      <ReportModalComponent :type="reportType" v-if="isAuthenticated && reportType" @closeModal="reportType = null"></ReportModalComponent>
      <CareTeamJoinConsentModal :journalCareplanId="careteamJoinCode" :prescriberId="prescriberId" :is-show="careteamJoinModal" @close="careteamJoinModal = !careteamJoinModal"/>
    </app-layout>
  </div>
</template>

<script>
import Utils from '@/utils.js'
import VueCookie from 'vue-cookie'
import logo from '@/assets/logo.png'
import moment from 'moment'
import _ from 'lodash';
import ResourcesFollowersListComponentVue from '@/components/ResourcesFollowersListComponent.vue'
import FeaturedFeedComponent from '@/components/FeaturedFeedComponent'
import AlertNotif from '@/components/AlertNotifModal'
import ModalHolder from "@/components/ModalHolderComponent"
import SystemAlertComponent from "@/components/SystemAlertComponent"
import FeedList from '@/components/FeedListComponent'
import ReportModalComponent from '@/components/ReportModalComponent'
import CareTeamJoinConsentModal from '@/components/CareTeamJoinConsentModal'
import ResilienceDoughnut from '@/components/ResilienceDoughnut'
import { mapGetters } from "vuex";
import { Message } from "iview"

let aInterval = null

export default {
  name: 'HomeComponent',
  components: {
    ResilienceDoughnut,
    FeaturedFeedComponent,
    AlertNotif,
    ModalHolder,
    SystemAlertComponent,
    FeedList,
    ReportModalComponent,
    CareTeamJoinConsentModal
  },
  created() {
    clearInterval(window.homePoll)
    window.homePoll = this.checkForNewFeedItem()
    this.$store.dispatch('feature/getFeaturedActivity', null, {root:1})
      if(this.userInfo
        && 'user_type' in this.userInfo
        && this.userInfo.user_type !== 'guest') {

        if( !VueCookie.get('PRESCRIPTION_GROUP') )
          this.$store.dispatch('user/getUserGroupInvitation', {id: this.$store.state.user.info.journal_id})
        this.$store.dispatch('user/getUserPendingInvitation')

        // this.$store.dispatch('user/getSpecial');
      } else {
        if (VueCookie.get("os_type") === "ios" && !VueCookie.get('ios_app_version') ) {
          window.webkit.messageHandlers.onNativeCalled.postMessage({
            name: "authLogin",
            params: {}
          });
          return false;
        } else {
          this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signin`)
        }
      }
  },
  mounted() {
    
    if (this.userInfo.user_type != "guest" && 
      _.get(this.userInfo, "email") &&
      this.userInfo.email.length === 0 &&
      _.get(this.userInfo, "mobile") &&
      this.userInfo.mobile.length === 0
    ) {
      this.$router.replace("/onboarding");
    }

    BroadcastEvent.$on('onSignout', () => {
      setTimeout( () => {
        this.getShareableActivity();
        this.$vlf.createInstance({
          storeName: 'systemAlert'
          }).then((v) => {
          v.removeItem('remindLater');
          clearInterval(checkReminder)
        })
      }, 0)
    })

    this.checkForCareTeamInvite()

    // this.$store.dispatch('user/category');

    // let activityLoader = function() {
    //   aInterval = setInterval( () => {
    //     let activity = this.$store.getters['user/lastLatestActivity'],
    //         latestActivity = (activity.rrule_parsed_date) ? activity.rrule_parsed_date.substr(0, 10) : null,
    //         dd = new Date(latestActivity);

    //     if ( latestActivity )
    //       this.$store.dispatch('user/getLatestUserFeed', {startDate: dd.toISOString().substr(0, 10)}).then((res) => {
    //         for( let x = 0; x<res.items.length; x++) {
    //           let found = this.$store.getters['user/findActivity'](res.items[x].id)
    //           if(!found) {
    //             this.$store.commit('user/addNewActivity', res.items[x]);
    //           }
    //         }
    //       })
    //   }, 20000 )
    // }.bind(this)

    // activityLoader();

    if( this.userInfo && this.userInfo.user_type !== 'guest' ) {
      this.$vlf.createInstance({
        storeName: 'humanity'
      }).then( s => {
        s.removeItem('code')
        s.removeItem('isVerified')
        s.removeItem('mobile')
      })

      if( VueCookie.get('PRESCRIPTION_CODE') &&
       !VueCookie.get('PRESCRIPTION_CODE_TYPE') &&
       VueCookie.get('PRESCRIPTION_CODE_TYPE') !== 'private_journal')
        this.$store.dispatch('base/acceptPrescriptionCode', {code:VueCookie.get('PRESCRIPTION_CODE')})
          .then( res => {
            VueCookie.delete('PRESCRIPTION_CODE');
            VueCookie.delete('PRESCRIPTION_GROUP');
            VueCookie.delete('PRESCRIPTION_USER_STORY');
          }, err => {
            VueCookie.delete('PRESCRIPTION_CODE');
            VueCookie.delete('PRESCRIPTION_GROUP');
            VueCookie.delete('PRESCRIPTION_USER_STORY');
          })
    }
    this.getShareableActivity()
    // this.$store.commit('base/setAlertModal', true);
    this.showUnverifiedAlert = !this.isUserVerified

    if(this.showUnverifiedAlert){
      this.AccountVerificationModal = true;
    }
  },
  beforeDestroy() {
    // console.log('Clearing...')
    clearInterval(aInterval)
    clearInterval(window.homePoll)
  },
  data () {
    return {
      showUnverifiedAlert: false,
      verificationModal: false,
      AccountVerificationModal: false,
      isVerifying: false,
      verificationCode: "",
      isResending: false,
      state: 'prompt',
      appLogo: logo,
      permission: false,
      comingSoon: false,
      currentShared: 0,
      // showSystemAlert: false,
      reportType: null,
      // showAlert: false,
      prescriberId: "",
      careteamJoinModal: false,
      careteamJoinCode: ""
    }
  },
  computed: {
    ...mapGetters("user", ["isAllowPoints", "userInfo", "isHomeFeedLoading", "activityList"]),
    ...mapGetters("base", ["loadingUser"]),
    verificationCookie() {
      return JSON.parse(
        VueCookie.get(Cons[0].PATHS.NAME + "VERIFICATION_SENT")
      );
    },
    mobile() {
      let firstUnverifiedMobile = _.filter(this.userInfo.mobile, mobile => {
        return mobile.validated_at == null;
      });

      return this.verificationCookie
        ? this.verificationCookie.mobile
        : firstUnverifiedMobile.length > 0
        ? firstUnverifiedMobile[0].mobile
        : "";
    },
    email() {
      let firstUnverifiedEmail = _.filter(this.userInfo.email, email => {
        return email.validated_at == null;
      });

      return this.verificationCookie
        ? this.verificationCookie.email
        : firstUnverifiedEmail.length > 0
        ? firstUnverifiedEmail[0].email
        : "";
    },
    isUserVerified() {
      if (this.userInfo.user_type !== "guest") {
        return _.filter(this.userInfo.email, (o) => {
          return o.validated_at
        }).length > 0 || _.filter(this.userInfo.mobile, (o) => {
          return o.validated_at
        }).length > 0;
      }
    },
    isLoadingBrandInfo() {
      return this.$store.state.user.isLoadingBrandInfo
    },
    isShareableActivity() {
      // shareableActivity.data[currentShared] && shareableActivity.data[currentShared].type === 'call_to_action'
      return _.get( this.shareableActivity, `data[${this.currentShared}].type`, null ) === "call_to_action";
    },
    shareableActivityData() {
      // isAuthenticated && showSystemAlert && shareableActivity && shareableActivity.data && shareableActivity.data.length > 0
      return _.get( this.shareableActivity, 'data', [] )
    },
    isAuthenticated() {
      return (!this.loadingUser && (localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')) && this.userInfo)
      // return (VueCookie.get(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE') && this.userInfo && "id" in this.userInfo && this.userInfo.id);
    },
    leadership() {
      return this.$store.state.user.leadership
    },
    admin() {
      return 'resources/'+ Cons[0].GROUP_ID.leadership +'?tab=stats'
    },
    isLoadingNearBy: {
      get () {
        return this.$store.state.nearby.isLoadingNearBy
      }
    },
    nearby: {
      get () {
        return this.$store.state.nearby
      }
    },
    userInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    brandInfo: {
      get () {
        return this.$store.state.user.brand
      }
    },
    brands: {
      get () {
        return this.$store.state.user.brands
      }
    },
    brandPlanInfo: {
      get () {
        return this.$store.state.user.brandPlan
      }
    },
    getTotal: {
      get () {
        var total = this.$store.state.nearby.nearByWork.total
        return Utils.numFormatterToK(total)
      }
    },
    getTotalUsers: {
      get () {
        var total_users = this.$store.state.nearby.nearBy.total_users
        return Utils.numFormatterToK(total_users)
      }
    },
    shareableActivity: {
      get() {
        return this.$store.state.systemAlert.shareableActivity
      }
    },
    systemAlertPersist: {
      get() {
        return this.$store.state.systemAlert.persist;
      }
    },
    remindLater: {
      get() {
        return this.$store.state.systemAlert.remindLater;
      },
      set(v) {
        this.$store.commit('systemAlert/setRemindLater', v);
      }
    },
    nextAlertTime: {
      get() {
        return this.$store.state.systemAlert.nextAlertTime;
      }
    },
    showSystemAlert: {
      get() {
        if ( VueCookie.get('os_type') === "ios")
          return false;
        if (this.userInfo.user_type == 'guest')
          return false;
        return this.$store.state.systemAlert.showSystemAlert && this.shareableActivityData.length > 0
      },
      set(v) {
        this.$store.commit('systemAlert/setShowSystemAlert', v)
      }
    }
  },
  methods: {
    validateCode() {
      if (!this.verificationCode) {
        Message.warning("Verification code is required");
        return false;
      }
      return true;
    },
    closeVerificationModal() {
      this.verificationModal = false,
      this.verificationCode = ""
      
      if(this.showUnverifiedAlert){
      this.AccountVerificationModal = true;
      }
    },
    setIsVerificationSent(payload) {
      if (payload)
        VueCookie.set(Cons[0].PATHS.NAME + "VERIFICATION_SENT", payload);
      else VueCookie.delete(Cons[0].PATHS.NAME + "VERIFICATION_SENT");
    },
    async resendCode() {
      if (this.isResending) return;
        try {
          this.isResending = true;
          this.$store.commit("base/setLoadingPage", true, { root: 1 });
          let promises = [];
          if (this.mobile)
            promises.push(
              this.$store.dispatch("onBoarding/resendMobileCode", this.mobile)
            );
          if (this.email)
            promises.push(
              this.$store.dispatch("onBoarding/resendEmailCode", this.email)
            );
          await Promise.all(promises);
          this.setIsVerificationSent(
            JSON.stringify({
              email: this.email,
              mobile: this.mobile
            })
          );
          Message.success("Verification code sent");
        } catch (error) {
          Message.warning("Unable to resend verification code");
        } finally {
          this.isResending = false;
          this.$store.commit("base/setLoadingPage", false, { root: 1 });
        }
    },  
    async verifyCode() {
      if (!this.validateCode()) return;
       try {
        this.isVerifying = true;
        let result = await this.$store.dispatch(
          "onBoarding/validateCode",
          this.verificationCode
        );

        if (result.error) Message.warning("Invalid verification code");
        else {
          Message.success("Successfully verified");
          this.setIsVerificationSent(null);
          this.closeVerificationModal();
          this.AccountVerificationModal = false;
          this.showUnverifiedAlert = false

          this.$store.dispatch("user/getUser")
            .then(me => {
              this.$store.commit('user/setUserInfo', me.data)
            })
        }
      } catch (error) {
        Message.warning("Invalid verification code");
      } finally {
        this.isVerifying = false;
      }
    },
    checkForNewFeedItem() {
      if (this.$route.name == "HomePage-Brand" || this.$route.name == "HomePage"){
         return setInterval(() => {
          if (!this.isHomeFeedLoading){
            console.log("Checking for home feed updates")
            clearInterval(window.homePoll)
            this.$store.dispatch("user/getSingleUserFeed")
              .then(res => {
                let homeFirstItem = this.activityList.length > 0 ?
                this.activityList[0] : null

                if (res.items.length == 1 && homeFirstItem && homeFirstItem.id 
                  && homeFirstItem.id !== res.items[0].id) {
                  console.log("Fetching new home feed")
                  this.$store.dispatch("user/getUserFeed")
                    .finally(() => {
                      window.homePoll = this.checkForNewFeedItem()
                    })
                }
                else {
                  window.homePoll = this.checkForNewFeedItem()
                }
              })
          }
        }, 5000);
      }
      else {
        clearInterval(window.homePoll)
      }
    },
    checkForCareTeamInvite() {
      var presCodeType = VueCookie.get('PRESCRIPTION_CODE_TYPE')
      if (presCodeType && presCodeType === "private_journal"){
        this.prescriberId = VueCookie.get('PRESCRIPTION_PRESCRIBED_BY')
        this.careteamJoinModal = true
        this.careteamJoinCode = VueCookie.get('PRESCRIPTION_CODE')
      }
      //show modal
    },
    onviewprofile(v) {
      // console.log("test")
      this.$store.commit('setCurrentTab', 1, {root:1})
      this.$router.push( v ? "/profile/"+v : "/profile");
    },
    // showAlert() {
    //   this.$store.state.systemAlert.persist = true;
    //   this.$store.commit('systemAlert/setShowSystemAlert', true)
    // },
    shareAlert(user_id, activity) {
      var url = this.getActivityShareLink(activity);
      if (this.userInfo && this.userInfo.user_type !== 'guest' ) {
        FB.ui({
          method: 'share',
          href: url,
        }, function(response) {
          if (response) {
            var param = {
              user_id: user_id,
              activity_id: activity.id,
              action: 'shared'
            };
            this.$store.dispatch('systemAlert/doShareAction', param).then(res => {
              this.onCallToActionClose()
              // console.log(res)
              // console.log('shared')
            })
          } else {
            // console.log('cancel')
          }
        }.bind(this));
      } else {
        this.$store.commit('hitCheckpoint');
      }
    },
    skipAlert(user_id, activity) {
      if (this.userInfo && this.userInfo.user_type !== 'guest' ) {
            var param = {
              user_id: user_id,
              activity_id: activity.id,
              action: 'skipped'
            };
            this.$store.dispatch('systemAlert/doShareAction', param).then(res => {
              this.$store.commit('systemAlert/removeShareItem', {act:activity, this:this});
              if(this.shareableActivity.data && this.shareableActivity.data.length < 1){
                this.onCallToActionClose()
              }else if(!this.shareableActivity.data){
                this.onCallToActionClose()
              }
            })
      } else {
        this.$store.commit('hitCheckpoint');
      }
    },
    getActivityShareLink(act){
        return (act.type === "call_to_action" && act.data && act.data.url) ? act.data.url : ('https://preview.sharpenminds.com/preview/?activity_id=' + act.id)
    },
    showCallToAction() {
      setTimeout( () => {
        this.$store.state.systemAlert.showSystemAlert = true;
      }, 300)
    },
    onCallToActionClose() {
      this.$vlf.createInstance({
          storeName: 'systemAlert'
      }).then((v) => {
        v.setItem('showAlert', false);
        this.$set(this, 'showSystemAlert', false);
        v.removeItem('remindLater');
        clearInterval(checkReminder)
      })
    },
    onRemindLater() {
      this.$vlf.createInstance({
          storeName: 'systemAlert'
      }).then((v) => {
          v.setItem('remindLater', moment().add(15, 'm').format("DD/MM/YYYY HH:mm:ss"));
          v.setItem('showAlert', false);
          this.$set(this, 'showSystemAlert', false);
          checkReminder = setInterval( function() {
            v.getItem('remindLater').then( reminder => {
              var now  = moment();
              var then = moment(reminder, "DD/MM/YYYY HH:mm:ss");
              let duration = moment(now, "DD/MM/YYYY HH:mm:ss").diff(then, 'seconds');
              v.setItem('showAlert', (duration >= 0) ? true:false);
              this.$set(this, 'showSystemAlert', (duration >= 0) ? true:false);
              if (duration >= 0) clearInterval(window.checkReminder)
            });
          }.bind(this), 5000);
      })
    },
    dismiss() {
      // var date = new Date();
      this.$store.commit('base/showPWAInstallation', false);
      // VueCookie.set(Cons[0].PATHS.NAME + 'PWAINTALL', date)
    },
    createOrganization() {
      this.$router.push('/create-organization')
    },
    toSignUp() {
      if ( VueCookie.get('os_type') === "ios" && !VueCookie.get('ios_app_version')) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: 'authRegister',
          params: {}
        })
        return false;
      }

      this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signup`);
      // this.$router.replace({path: '/verify'})
    },
    setMemberMethod (type) {
      if ( VueCookie.get('os_type') === "ios" && !VueCookie.get('ios_app_version')) {
        if( type === "signin" )
          window.webkit.messageHandlers.onNativeCalled.postMessage({
            name: 'authLogin',
            params: {}
          })
        return false;
      }

      let prescriptionCode =
        'code' in this.$route.query && this.$route.query.code
          ? this.$route.query.code
          : null
      let prescription =
        'prescription' in this.$route.query && this.$route.query.prescription
          ? this.$route.query.prescription
          : null
      let pType =
        'ptype' in this.$route.query && this.$route.query.ptype
          ? this.$route.query.ptype
          : null

      if (pType && prescription && prescriptionCode && type) {
        this.$router.replace({
          path:
            '/login?ptype=' +
            pType +
            '&type=' +
            type +
            '&prescription=' +
            prescription +
            '&code=' +
            prescriptionCode
        })
      } else if (!pType && !prescription && !prescriptionCode && type) {
        this.$router.replace({ path: '/login?type=' + type })
      } else if (!type && pType && prescriptionCode && prescription) {
        this.$router.replace({
          path:
            '/login?prescription=' +
            prescription +
            '&code=' +
            prescriptionCode +
            '&ptype=' +
            pType
        })
      } else this.$router.replace({ path: '/login' })
      // console.log(type)
      // this.reportType = type
      // if(type == 'signin' || type == 'signup')
      //   this.$store.commit('menu/setShowWizardModalComponent', true)
    },
    showPermission () {
      // console.log('showPermission')
      this.$store.dispatch(
        'nearby/getPermissionState',
        this.$store.state.user.info.places.work
      )
      this.$store.commit('nearby/setShowEnableNearby', false)
    },
    dontAllow () {
      this.$store.commit('nearby/setLocalPermissionState', 'denied')
      this.$store.commit('nearby/setShowEnableNearby', true)
      this.permission = false
    },
    allow () {
      this.$store.commit('nearby/setLocalPermissionState', 'granted')
      this.$store.commit('nearby/setShowEnableNearby', false)
      this.$store.dispatch(
        'nearby/getPermissionState',
        this.$store.state.user.info
      )
      this.permission = false
    },
    userDisplayImage(user) {
      // console.log(user)
      //  user.avatar_uri
      if (user)
        return Utils.getDisplayImage('user', user, 'small')
      return null
    },
    groupDisplayImage(group) {
      return Utils.getDisplayImage('group', group, 'small')
    },
    getShareableActivity: _.debounce(function () {
      if(this.userInfo && this.userInfo.user_type == 'guest') return;
      this.$store.dispatch('systemAlert/getShareableActivity')
        .then(res => {
          if ((res && res.data.length > 0)) {
            this.$vlf.createInstance({
              storeName: 'systemAlert'
            }).then((v) => {
              v.getItem('shareableActivity').then(activity => {
                if (activity && activity.data && activity.data.length > 0) {
                  // exsiting to localstorage
                  if(this.checkNewData(res,activity)) {
                    // TODO NEW ACTIVITY POSTED
                    v.removeItem('remindLater');
                    clearInterval(checkReminder);
                    v.setItem('shareableActivity', res);
                    this.$store.commit('systemAlert/setShareableActivity', res);
                    this.$set(this, 'showSystemAlert', (res.data[0].user_action === null));
                    v.setItem('showAlert', true);
                  } else {
                    v.setItem('shareableActivity', res);
                    this.$store.commit('systemAlert/setShareableActivity', res);
                  }

                  v.getItem('showAlert').then( isShow => {
                    if (isShow) {
                      // showalert
                      this.$store.commit('systemAlert/setShareableActivity', activity);
                      v.setItem('showAlert', true);
                      v.removeItem('remindLater');
                      clearInterval(checkReminder)
                      this.$set(this, 'showSystemAlert', (res.data[0].user_action === null));
                    } else {
                      // showalert (false)
                      if (this.checkNewData(res,activity)) {
                        v.setItem('shareableActivity', res);
                        this.$store.commit('systemAlert/setShareableActivity', res);
                        v.removeItem('remindLater');
                        clearInterval(checkReminder)
                      }
                      v.setItem('showAlert',this.checkNewData(res,activity) && (res.data[0].user_action === null));
                      this.$set(this, 'showSystemAlert', (this.checkNewData(res,activity) && (res.data[0].user_action === null)));
                    }
                  });
                } else {
                  // new stored to localstorage
                  if((res.data.length > 0) && (res.data[0].user_action === null)){
                    v.removeItem('remindLater');
                    clearInterval(checkReminder);
                  }
                  v.setItem('shareableActivity', res);
                  this.$store.commit('systemAlert/setShareableActivity', res);
                  v.setItem('showAlert', (res.data.length > 0));
                  this.$set(this, 'showSystemAlert', ((res.data.length > 0) && (res.data[0].user_action === null)));
                }
              });
            })
          }else{
            this.$vlf.createInstance({
              storeName: 'systemAlert'
            }).then((v) => {
              this.$store.commit('systemAlert/setShareableActivity', {});      
              v.setItem('shareableActivity', {})
              v.setItem('showAlert', false)
            });
          }
        });
    },500),
    setCurrentSharedShown(v){
      this.currentShared = v;
    },
    checkNewData(data1,data2){
      return (data1.data[0].id !== data2.data[0].id) ||
              (data1.data[0].updated_at !== data2.data[0].updated_at) ||
              (data1.data.length !== data2.data.length)
    },
    showVerifyModal(){
      this.AccountVerificationModal = false;
      this.verificationModal = true;
    }
  }
}
</script>
